import { PageTemplate } from "../styles";
import { useState, useContext, useEffect } from "react";
import { DataContext } from "../DataContext";
import { useLocation } from "react-router-dom";
import SelectionModal from "./SelectionModal";
import ImageLoader from "../components/ImageLoader";
import { ASSET_URL } from "../constants";

const DesignSelection = () => {
  const { designs, visitedPages } = useContext(DataContext);
  const location = useLocation();

  const [selectedDesign, setSelectedDesign] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // component mount
  useEffect(() => {
    // failsafe to remove loader if not all images load
    setTimeout(() => {
      setShowLoading(false);
    }, 5000);
  }, []);

  // image loader
  const [imagesLoaded, setImagesLoaded] = useState(0);
  const [showLoading, setShowLoading] = useState(true);
  const totalImages = designs?.length || 0;
  const handleImageLoad = (designName) => {
    setImagesLoaded((prev) => prev + 1);
    const avif = new Image();
    avif.src = `${ASSET_URL}/designs/modal/male/front-${designName}.avif`;
  };
  useEffect(() => {
    if (imagesLoaded === totalImages) {
      setShowLoading(false);
    }
  }, [imagesLoaded, totalImages]);
  // image loader end

  const handleDesignSelection = (designName) => {
    const selected = designs.find((design) => design.designName === designName);
    if (!selected) return;
    setSelectedDesign(selected);
    setShowModal(true);
  };

  const renderDesigns = () => {
    const path = "/designs/folded-shirts/";
    return designs.map((design) => {
      return (
        <button onClick={() => handleDesignSelection(design.designName)} key={design.designName}>
          <picture>
            <source srcset={`${ASSET_URL}${path}${design.designName}-folded-shirt.avif`} type="image/avif" />
            <img
              onLoad={() => handleImageLoad(design.designName)}
              src={`${ASSET_URL}${path}${design.designName}-folded-shirt.jpg`}
              alt={design.designTitle}
            />
          </picture>
        </button>
      );
    });
  };

  const visited = visitedPages["/designs"] > 1 ? true : false;
  const loading = location.pathname === "/designs" && showLoading && !visited;

  return (
    <>
      <PageTemplate className="large">
        <h2>Ready? Choose a Design</h2>
        <div className="content-page grey">
          <div className={`designs-container ${loading && "loadingImages"}`}>
            <ImageLoader imagesLoaded={imagesLoaded} totalImages={totalImages} />

            {renderDesigns()}
          </div>
        </div>
      </PageTemplate>
      <SelectionModal
        selectedDesign={selectedDesign}
        setSelectedDesign={setSelectedDesign}
        showModal={showModal}
        setShowModal={setShowModal}
      />
    </>
  );
};

export default DesignSelection;
